import { HyperpayFinalizedCheckoutInfoType } from "../../../components/payment/HyperpayCheckoutInfo";
import { ApiResponse } from "../../apiResponse";
import Axios from "../../axios";

export type HyperpayCheckoutRequestBody = HyperpayFinalizedCheckoutInfoType & {
  currency: string;
};

export function createHyperpayCheckoutSession(
  body: HyperpayCheckoutRequestBody
): Promise<ApiResponse> {
  return Axios.post("v1/subscriptions/program_hyperpay_subscription", body);
}

export function verifyHyperpayCheckoutPayment(
  paymentIntentId: string
): Promise<ApiResponse> {
  return Axios.post("v1/subscriptions/verify_payment", {
    payment_intent: paymentIntentId,
  });
}

export function savePaymentAddress(
  body: Omit<
    HyperpayFinalizedCheckoutInfoType,
    "amount" | "first_name" | "last_name" | "currency"
  >
): Promise<ApiResponse> {
  return Axios.patch("v1/accounts/update_account_address", body);
}
